import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const QualityPage = () => {
  const certifications = [
    {
      icon: 'ri-award-line',
      title: 'ISO 13485',
      description: 'Système de management de la qualité pour les dispositifs médicaux',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'CE Marking',
      description: 'Conformité aux exigences européennes en matière de sécurité',
    },
    {
      icon: 'ri-verified-badge-line',
      title: 'FDA Approved',
      description: 'Approbation de la Food and Drug Administration américaine',
    },
    {
      icon: 'ri-medal-line',
      title: 'ISO 9001',
      description: 'Management de la qualité et amélioration continue',
    },
  ];

  const qualityStandards = [
    {
      icon: 'ri-search-eye-line',
      title: 'Contrôle qualité',
      description: 'Processus de vérification rigoureux à chaque étape',
    },
    {
      icon: 'ri-route-line',
      title: 'Traçabilité',
      description: 'Système complet de traçabilité pour tous nos produits',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Conformité réglementaire',
      description: 'Respect strict des réglementations algériennes et internationales',
    },
  ];

  const supplyChainChecks = [
    'Inspection à la réception',
    'Tests de conformité',
    'Vérification des certifications',
    'Contrôle de stérilité',
    'Audit qualité régulier',
  ];

  const medicalDeviceChecks = [
    'Numéros de lot uniques',
    'Dates de péremption contrôlées',
    'Origine documentée',
    'Historique complet disponible',
    'Système de rappel efficace',
  ];

  const internationalCompliance = [
    'Conformité au Ministère de la Santé',
    'Normes ISO respectées',
    'Documentation complète',
    'Mises à jour réglementaires',
    'Audits de conformité',
  ];

  const complianceProcess = [
    {
      number: '1',
      title: 'Réception',
      description: 'Inspection et vérification des produits à l\'arrivée',
    },
    {
      number: '2',
      title: 'Contrôle',
      description: 'Tests de conformité et validation qualité',
    },
    {
      number: '3',
      title: 'Stockage',
      description: 'Conservation dans des conditions optimales',
    },
    {
      number: '4',
      title: 'Distribution',
      description: 'Livraison sécurisée selon les protocoles',
    },
  ];

  const qualityCommitments = [
    {
      icon: 'ri-user-search-line',
      title: 'Sélection des fournisseurs',
      description: 'Choix rigoureux de partenaires certifiés et reconnus internationalement',
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Contrôle à la réception',
      description: 'Vérification systématique de la conformité et de la qualité des produits',
    },
    {
      icon: 'ri-archive-line',
      title: 'Stockage contrôlé',
      description: 'Conditions optimales de conservation selon les normes pharmaceutiques',
    },
    {
      icon: 'ri-truck-line',
      title: 'Distribution sécurisée',
      description: 'Livraison dans le respect de la chaîne du froid et des protocoles de sécurité',
    },
  ];

  const guaranteeCards = [
    {
      icon: 'ri-test-tube-line',
      title: 'Tests rigoureux',
      description: 'Chaque lot de produits est testé selon les protocoles les plus stricts avant distribution',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Documentation complète',
      description: 'Tous nos produits sont accompagnés de certificats de conformité et notices d\'utilisation',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Amélioration continue',
      description: 'Révision régulière de nos processus pour maintenir les plus hauts standards de qualité',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Formation continue',
      description: 'Notre équipe est régulièrement formée aux dernières normes et réglementations',
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Garantie qualité',
      description: 'Engagement de remplacement ou remboursement en cas de non-conformité avérée',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Support technique',
      description: 'Assistance et conseil pour l\'utilisation optimale de nos dispositifs médicaux',
    },
  ];

  const documentation = [
    {
      icon: 'ri-file-shield-2-line',
      title: 'Certificats de conformité',
      description: 'Tous les certificats et attestations de conformité de nos produits',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Notices d\'utilisation',
      description: 'Guides d\'utilisation détaillés en français et en arabe',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Fiches techniques',
      description: 'Spécifications techniques complètes de nos dispositifs médicaux',
    },
  ];

  return (
    <>
      <header>
        <h1 className="sr-only">Qualité et Conformité - SARL ADF Biomédical - Certifications ISO et normes internationales en Algérie</h1>
      </header>
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-5xl md:text-6xl font-bold text-[#1A1A1A] mb-6">
                Qualité & Conformité
              </h2>
              <p className="text-xl text-[#4A4A4A] mb-4 max-w-3xl mx-auto">
                Notre engagement pour l'excellence et la sécurité
              </p>
              <p className="text-base text-[#4A4A4A] max-w-2xl mx-auto">
                <strong>Certifications internationales</strong> — Nos dispositifs médicaux sont certifiés selon les normes les plus strictes
              </p>
            </motion.div>
          </div>
        </section>

        {/* Certifications Internationales */}
        <section className="py-20 bg-[#F8F8F8]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {certifications.map((cert, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white rounded-lg p-8 text-center hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-[#E31B23]/10 rounded-full">
                    <i className={`${cert.icon} text-4xl text-[#E31B23]`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1A1A1A] mb-3">{cert.title}</h3>
                  <p className="text-sm text-[#4A4A4A] leading-relaxed">{cert.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Nos Standards de Qualité */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h3 className="text-4xl font-bold text-[#1A1A1A] mb-4">Nos standards de qualité</h3>
              <p className="text-lg text-[#4A4A4A]">
                Un processus rigoureux pour garantir la sécurité et l'efficacité
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {qualityStandards.map((standard, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-[#F8F8F8] rounded-lg p-8 text-center"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-[#E31B23]/10 rounded-full">
                    <i className={`${standard.icon} text-4xl text-[#E31B23]`}></i>
                  </div>
                  <h4 className="text-xl font-semibold text-[#1A1A1A] mb-3">{standard.title}</h4>
                  <p className="text-base text-[#4A4A4A] leading-relaxed">{standard.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Checklist en 3 Colonnes */}
        <section className="py-20 bg-[#F8F8F8]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h4 className="text-xl font-bold text-[#1A1A1A] mb-6">Chaîne d'approvisionnement</h4>
                <ul className="space-y-4">
                  {supplyChainChecks.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-[#E31B23] text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-base text-[#4A4A4A]">{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <h4 className="text-xl font-bold text-[#1A1A1A] mb-6">Dispositifs médicaux</h4>
                <ul className="space-y-4">
                  {medicalDeviceChecks.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-[#E31B23] text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-base text-[#4A4A4A]">{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h4 className="text-xl font-bold text-[#1A1A1A] mb-6">Conformité internationale</h4>
                <ul className="space-y-4">
                  {internationalCompliance.map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-[#E31B23] text-xl mr-3 mt-0.5 flex-shrink-0"></i>
                      <span className="text-base text-[#4A4A4A]">{item}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Notre Processus de Conformité */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h3 className="text-4xl font-bold text-[#1A1A1A] mb-4">Notre processus de conformité</h3>
              <p className="text-lg text-[#4A4A4A]">
                Un parcours structuré pour garantir la qualité à chaque étape
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {complianceProcess.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="text-center"
                >
                  <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-[#E31B23] rounded-full">
                    <span className="text-3xl font-bold text-white">{step.number}</span>
                  </div>
                  <h4 className="text-xl font-bold text-[#1A1A1A] mb-3">{step.title}</h4>
                  <p className="text-base text-[#4A4A4A] leading-relaxed">{step.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Nos Engagements Qualité */}
        <section className="py-20 bg-[#F8F8F8]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h3 className="text-4xl font-bold text-[#1A1A1A] mb-4">Nos engagements qualité</h3>
              <p className="text-lg text-[#4A4A4A]">
                Des garanties concrètes pour votre tranquillité d'esprit
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {qualityCommitments.map((commitment, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white rounded-lg p-8 flex items-start"
                >
                  <div className="w-12 h-12 flex items-center justify-center mr-6 bg-[#E31B23]/10 rounded-lg flex-shrink-0">
                    <i className={`${commitment.icon} text-2xl text-[#E31B23]`}></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-[#1A1A1A] mb-2">{commitment.title}</h4>
                    <p className="text-base text-[#4A4A4A] leading-relaxed">{commitment.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Grande Section Rouge - Garanties */}
        <section className="py-20 bg-[#E31B23]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {guaranteeCards.map((card, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-white/20 rounded-full">
                    <i className={`${card.icon} text-4xl text-white`}></i>
                  </div>
                  <h4 className="text-xl font-bold text-white mb-3">{card.title}</h4>
                  <p className="text-base text-white/90 leading-relaxed">{card.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Documentation Disponible */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h3 className="text-4xl font-bold text-[#1A1A1A] mb-4">Documentation disponible</h3>
              <p className="text-lg text-[#4A4A4A]">
                Accédez à toute la documentation nécessaire pour vos dispositifs médicaux
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {documentation.map((doc, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-[#F8F8F8] rounded-lg p-8 text-center"
                >
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-[#E31B23]/10 rounded-full">
                    <i className={`${doc.icon} text-4xl text-[#E31B23]`}></i>
                  </div>
                  <h4 className="text-xl font-semibold text-[#1A1A1A] mb-3">{doc.title}</h4>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">{doc.description}</p>
                  <Link
                    to="/contact"
                    className="inline-block px-6 py-2.5 bg-[#E31B23] text-white rounded-lg font-medium hover:bg-[#C41820] transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Demander
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-24 bg-[#F8F8F8]">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h3 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6">
                Des questions sur nos standards de qualité ?
              </h3>
              <p className="text-xl text-[#4A4A4A] mb-10">
                Notre équipe qualité est à votre disposition pour répondre à toutes vos questions
              </p>
              <Link
                to="/contact"
                className="inline-block px-12 py-4 bg-[#E31B23] text-white rounded-lg font-semibold text-lg hover:bg-[#C41820] transition-all duration-300 shadow-lg hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Contactez notre équipe qualité
              </Link>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default QualityPage;
